<template>
    <div>
        <h1>支付宝付款</h1>
        <div style="width:300px">
            <el-form ref="alipayBean" :model="alipayBean" label-width="80px">
                <el-form-item label="商户订单号">
                    <el-input placeholder="请输入" v-model="alipayBean.out_trade_no"></el-input>
                </el-form-item>
                <el-form-item label="订单名称">
                    <el-input placeholder="请输入" v-model="alipayBean.subject"></el-input>
                </el-form-item>
                <el-form-item label="付款金额">
                    <el-input placeholder="请输入" v-model="alipayBean.total_amount"></el-input>
                </el-form-item>
                <el-form-item label="商品描述">
                    <el-input placeholder="请输入" v-model="alipayBean.body"></el-input>
                </el-form-item>
            </el-form>
            <el-button @click="submit">付款</el-button>
            <el-button @click="query">查询</el-button>

        </div>




    </div>
</template>
<script>
import { alipay,alipaySelect } from "@/api/pay.js";
export default {
    data() {
        return {
            alipayBean: {
                out_trade_no: "", //商户订单号
                subject: "", //订单名称
                total_amount: "", //付款金额
                body: "", //商品描述
            },
        };
    },
    methods: {
        submit() {
            alipay(this.alipayBean).then((res) => {
                console.log(res);
                window.location.href = res.msg 
            });
        },
        query() {
            //123456123456  12312312321
            select(this.alipayBean).then((res) => {
                // console.log(eval("("+res.msg+")"));
                console.log(JSON.parse(res.msg));
                
            });
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/view/pay/alipay.vue